export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15132.e8f5dcfe.jpg";